import classNames from 'classnames';
import { Link } from 'gatsby';
import React from 'react';

import {
  getTitle,
  getDescription,
  getFeaturedImage,
  getSlug,
} from '../utils/blogData';
import { getBlogDisplayDate } from '../utils/dates';

export default function PartialBlog({ post, type }) {
  const description = getDescription(post);
  const title = getTitle(post);
  const imgSrc = getFeaturedImage(post);
  const slug = getSlug(post, type);
  const primary = post?.body ? post.body[0]?.primary : null;
  const logos = [];
  if (primary?.logo_1?.url) logos.push(primary?.logo_1?.url);
  if (primary?.logo_2?.url) logos.push(primary?.logo_2?.url);
  if (primary?.logo_3?.url) logos.push(primary?.logo_3?.url);
  return (
    <>
      <div className="blog--card--wrapper fade-up col-span-4 h-full md:col-span-6">
        <Link
          to={`/${slug}`}
          className="blog--card bg--white fade-up flex h-full pt-6 lg:pt-10">
          <div className="blog--card--image flex-none">
            <img
              loading="lazy"
              decoding="async"
              src={imgSrc}
              alt=""
              className={classNames('blog--card--bg h-full object-cover', {
                '!object-contain object-top':
                  post?.page_type === 'whitepaper' ||
                  post?.page_type === 'ebook' ||
                  post?.page_type === 'webinar',
              })}
            />
          </div>
          <div className="pb-4 pl-4 pr-4 lg:pb-8 lg:pl-10 lg:pr-10">
            <div className="flex h-full flex-col justify-between">
              <div>
                <div className="eyebrow color--grey-4 mb-2">
                  {getBlogDisplayDate(post.date)}
                </div>
                <p className="h4 mb-4">{title}</p>
                <p
                  className="small color--grey-5 truncate-overflow hidden lg:block"
                  dangerouslySetInnerHTML={{
                    __html: description,
                  }}
                />
                {logos && (
                  <div className="flex">
                    {logos.map((logo, index) => (
                      <img
                        src={logo}
                        key={index}
                        className="mr-2 h-auto max-h-[30px] w-auto max-w-[60px]"
                        alt=""
                      />
                    ))}
                  </div>
                )}
              </div>
              <svg
                className="mt-4 lg:mt-6"
                width="20"
                height="17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.25 0L9.562 1.636l5.782 5.606H0v2.546h15.344l-5.75 5.576L11.28 17 20 8.515 11.25 0z"
                  fill="#44433F"
                />
              </svg>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
}
